import * as React from 'react';
import type { GetStaticProps } from 'next';
import { queryFooter, queryNavbar } from '@/clients/queries';
import { FooterQuery, NavbarQuery } from 'types/generated';
import PageContainer from '@/components/PageContainer';
import { apolloClient } from '@/utils/contentful';
import SearchPage from '@/components/Search/SearchPage';
import { ApolloProvider } from '@apollo/client';
import { createApolloClientForSearch } from '@/clients/apollo';
import { getRadioSchedules } from '@/clients/RadioUtils';
import { RadioSchedule } from '@/models/RadioTypes';
import { Log } from '@/logging/datadog';

type Props = {
  navbar: NavbarQuery;
  footer: FooterQuery;
  radioSchedules: Record<string, RadioSchedule[]>;
};

const RouteComponent = ({ navbar, footer, radioSchedules }: Props) => {
  const mainNavbarData = navbar.navbarCollection?.items?.[0];

  return (
    <PageContainer
      title="Sýn | Leit"
      metaTags={{
        title: 'Sýn leit',
        url: 'https://www.syn.is/leit',
        keywords: 'syn,leit',
        image: { url: '/android-chrome-192x192.png' },
      }}
      navbar={navbar}
      footer={footer}
      radioSchedules={radioSchedules}
    >
      <div className="col-span-full w-full pt-128">
        <ApolloProvider client={createApolloClientForSearch()}>
          <SearchPage suggestions={mainNavbarData?.searchSuggestionsCollection?.items || []} />
        </ApolloProvider>
      </div>
    </PageContainer>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  try {
    return {
      props: {
        navbar: (await queryNavbar(apolloClient)).data,
        footer: (await queryFooter(apolloClient)).data,
        radioSchedules: await getRadioSchedules(),
      },
    };
  } catch (err) {
    Log.error((err as Error).message || '', err);
    throw err;
  }
};

export default RouteComponent;
